<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.cancellingPcnTitle"></div>
    <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="hours" />
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
